import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

function fmtHour(t) {
  try {
    const d = new Date(t);
    return `${d.getHours().toString().padStart(2, "0")}h`;
  } catch {
    return t;
  }
}

export function WindChart({ hourly = [] }) {
  const data = hourly.map((h) => ({
    hour: fmtHour(h.time),
    vento: Math.round(h.wind_speed),
    raffica: Math.round(h.wind_gusts),
  }));

  return (
    <div className="w-full h-64" data-testid="wind-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="gVento" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0ea5e9" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#0ea5e9" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gRaffica" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ea580c" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#ea580c" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="hour" tick={{ fontSize: 11, fill: "#94a3b8" }} interval={2} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} unit="kn" />
          <Tooltip
            contentStyle={{
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              fontFamily: "DM Sans",
              fontSize: 13,
            }}
            formatter={(v, n) => [`${v} kn`, n === "vento" ? "Vento" : "Raffica"]}
          />
          <Area type="monotone" dataKey="raffica" stroke="#ea580c" strokeWidth={2} fill="url(#gRaffica)" />
          <Area type="monotone" dataKey="vento" stroke="#0284c7" strokeWidth={2.5} fill="url(#gVento)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
